import { PlayerId } from "@presidents/game-engine/src/types";
import { useCallback, useState } from "react";
import { useGameRoomStateChange } from "../context/GameRoomState";

export default function usePresidentFound() {
  const [presidentFound, setPresidentFound] = useState(false);
  const reset = useCallback(() => {
    setPresidentFound(false);
  }, []);
  useGameRoomStateChange((currRoomState, nextRoomState) => {
    if (currRoomState && nextRoomState) {
      const handStats = currRoomState.currentGame?.state.handStats;
      const nextHandStats = nextRoomState.currentGame?.state.handStats;
      if (handStats && nextHandStats) {
        let whoWentOut: undefined | PlayerId = undefined;
        for (const [playerId, { isOut }] of Object.entries(nextHandStats)) {
          if (isOut && !handStats[playerId].isOut) {
            whoWentOut = playerId;
            break;
          }
        }
        if (whoWentOut && currRoomState.currentGame?.state.out.length === 0) {
          setPresidentFound(true);
        }
      }
    }
  });
  return [presidentFound, reset];
}
